import { render, staticRenderFns } from "./suppliersList.vue?vue&type=template&id=615c582f&scoped=true&"
import script from "./suppliersList.vue?vue&type=script&lang=js&"
export * from "./suppliersList.vue?vue&type=script&lang=js&"
import style0 from "./suppliersList.vue?vue&type=style&index=0&id=615c582f&lang=scss&scoped=true&"
import style1 from "./suppliersList.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "615c582f",
  null
  
)

export default component.exports